import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Typography } from '@iho-design-system/Loader';

const HotelInfo = ({ requestType, sendRequestStatusProps, hotelInfoProps }) => {

    /*
        - defaultData
    */
    const [hotelInfo, setHotelInfo] = React.useState({});

    /*
        - handleHotelInfo
    */
    const handleHotelInfo = (event, option) => {
        if (event.target.classList[5] === undefined) {
            setHotelInfo(prev => ({ ...prev, [option]: option }));
            event.target.classList.add('active');
            event.target.style.setProperty('background-color', '#5c5b69', 'important');
            event.target.style.setProperty('color', '#ffffff', 'important');
        } else {
            setHotelInfo(prev => ({ ...prev, [option]: '-1' }));
            event.target.classList.remove('active');
            event.target.style.setProperty('background-color', '#ffffff', 'important');
            event.target.style.setProperty('color', '#5c5b69', 'important');
        }
    }

    React.useEffect(() => {
        let keys = Object.keys(hotelInfo);
        let sendRequestStatus = false;
        keys.forEach((obj) => {
            if (hotelInfo[obj] !== '' && hotelInfo[obj] !== '-1') {
                sendRequestStatus = true;
                hotelInfoProps(hotelInfo);
            }
        });
        sendRequestStatusProps(sendRequestStatus);
    }, [hotelInfo]);

    React.useEffect(() => {
        setHotelInfo({});
    }, [requestType]);

    return (

        <React.Fragment>

            {requestType.split(',')[1] === 'hotelInfo' && requestType.split(',')[3] === 'selectReserve' && requestType.split(',')[4] === undefined &&
                <Box
                    className={`w-100 my-lg mb-0 border-solid-top border-medium`}>
                    <Typography
                        className={`py-md`}
                        component='h5'>
                        لیست اطلاعات
                    </Typography>
                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '0')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    قوانین کنسلی
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '1')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1.1s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    قوانین عمومی
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '2')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1.2s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    تلفن تماس
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '3')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1.3s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    آدرس و لوکیشن
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '4')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1.4s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    ساعت ورود و خروج
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'
                                ms={{
                                    padding: 'var(--sizing-xs)'
                                }}>
                                <Button
                                    onClick={(event) => handleHotelInfo(event, '5')}
                                    size='xs'
                                    ms={{
                                        width: '100%',
                                        marginLeft: '4px',
                                        padding: '4px',
                                        fontSize: '85%',
                                        color: 'var(--gray-dark) !important',
                                        backgroundColor: 'var(--white) !important',
                                        border: '1px solid var(--gray-medium)',
                                        opacity: '0',
                                        animation: 'reserveAnimation 0.5s linear',
                                        animationDelay: '1.5s',
                                        animationFillMode: 'forwards',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light) !important'
                                        }
                                    }}>
                                    اطلاعات و امکانات
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Box>
            }

        </React.Fragment>

    );

}

export default HotelInfo;